import { actions } from "@shared/template/StoreTemplates/FilterStoreTemplate"

export default {
  ...actions
}
